import React, { useState, useEffect } from 'react'
import { Box, Grid, Paper, ActionIcon, SimpleGrid, Text, Badge, Drawer, NumberFormatter, Card, Group, Flex, Skeleton, Avatar, Modal, ScrollArea } from '@mantine/core'
import { useSelector } from 'react-redux'
import { IconPencilMinus, IconCircleXFilled, IconCircleCheckFilled } from '@tabler/icons-react'
import { getDetailUser } from '../../../../services/users'
import FormAdjustCustomPayment from './Form/FormAdjustCustomPayment'
import FormAdjustCurrency from './Form/FormAdjustCurrency'
import FormAdjustGeneralInfo from './Form/FormAdjustGeneralInfo'
import FormAdjustPaymentStatus from './Form/FormAdjustPaymentStatus'
import FormAdjustOrderStatus from './Form/FormAdjustOrderStatus'
import FormAdjustOrderFreight from './Form/FormAdjustOrderFreight'
import FormAdjustOrderInsurence from './Form/FormAdjustOrderInsurence'
import FormAdjustAgent from './Form/FormAdjustAgent'
import FormAdjustPaymentMethod from './Form/FormAdjustPaymentMethod'
import FormAdjustBillingAndShipping from './Form/FormAdjustBillingAndShipping'
import OrderPaymentMethod from './LayoutHelper/OrderPaymentMethod'
import dayjs from 'dayjs'

const defaultDataUser = {
  id: null,
  name: ''
}

const OrderGeneralInfo = () => {
  const { isLoadingOrder, summary, general } = useSelector(state => state.order_detail)
  const [openEditCustomPayment, setOpenEditCustomPayment] = useState(false)
  const [openEditCurrency, setOpenEditCurrency] = useState(false)
  const [openEditGeneralInfo, setOpenEditGeneralInfo] = useState(false)
  const [openEditPaymentStatus, setOpenEditPaymentStatus] = useState(false)
  const [openEditOrderStatus, setOpenEditOrderStatus] = useState(false)
  const [openEditOrderFreight, setOpenEditOrderFreight] = useState(false)
  const [openEditOrderInsurence, setOpenEditOrderInsurence] = useState(false)
  const [openEditPaymentMethod, setOpenEditPaymentMethod] = useState(false)
  const [openEditShippingOrder, setOpenEditShippingOrder] = useState(false)
  const [typeShipping, setTypeShipping] = useState('billing')
  const [detailUserAgent, setDetailUserAgent] = useState(defaultDataUser)
  const [loadingUserAgent, setLoadingUserAgent] = useState(true)
  const [openEditAgent, setOpenEditAgent] = useState(false)

  const getDataUserAgent = async (userId) => {
    setLoadingUserAgent(true)
    try {
      const response = await handleGetDetailUser(userId)
      setDetailUserAgent(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUserAgent(false)
    }
  }

  const handleGetDetailUser = async(userId) => {
    try {
      const response = await getDetailUser(userId)
      const dataUser = response.data.attributes
      const remapData = {
        id: dataUser.id,
        name: dataUser.name
      }
      return remapData
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (summary) {
      if (summary.agentId) {
        getDataUserAgent(summary.agentId)
      } else {
        setLoadingUserAgent(false)
        setDetailUserAgent(defaultDataUser)
      }
    }
    // eslint-disable-next-line
  }, [summary])

  const onCloseFormCustomPayment = () => {
    setOpenEditCustomPayment(false)
  }

  const onCloseFormCurrency = () => {
    setOpenEditCurrency(false)
  }

  const onCloseFormGeneralInfo = () => {
    setOpenEditGeneralInfo(false)
  }

  const onCloseFormPaymentStatus = () => {
    setOpenEditPaymentStatus(false)
  }

  const onCloseFormOrderStatus = () => {
    setOpenEditOrderStatus(false)
  }

  const onCloseFormOrderFreight = () => {
    setOpenEditOrderFreight(false)
  }

  const onCloseFormOrderInsurence = () => {
    setOpenEditOrderInsurence(false)
  }

  const onCloseFormPaymentMethod = () => {
    setOpenEditPaymentMethod(false)
  }

  const onCloseFormAgent = () => {
    setOpenEditAgent(false)
  }

  const onCloseFormShippingOrder = () => {
    setOpenEditShippingOrder(false)
  }

  const loadingDataUser = () => {
    return (
      <Flex gap='sm' align='center' mb={14}>
        <Skeleton height={40} circle />
        <Box w={100}>
          <Skeleton height={14} radius="xl" />
        </Box>
      </Flex>
    )
  }

  const mappingUserAgent = (value) => {
    if (value.id !== null) {
      return (
        <Flex gap='sm' align='center' mb={16}>
          <Avatar variant='filled' name={value.name} radius="xl" size="md" color='red' />
          <Box>
            <Text fz={13} fw='bold' lineClamp={2}>{value.name}</Text>
          </Box>
        </Flex>
      )
    } else {
      return (
        <Flex gap='sm' align='center' mb={16}>
          <Avatar variant='filled' name='NA' radius="xl" size="md" color='red' />
          <Box>
            <Text fz={13} fw='bold' lineClamp={2}>No Agent</Text>
          </Box>
        </Flex>
      )
    }
  }


  return (
    <Box>
      <Box my={20}>
        <Box mb={20}>
          <Grid>
            <Grid.Col span={5}>
            <Paper shadow="xs" p='md' withBorder style={{ position:'relative' }}>
              <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditCustomPayment(true)}>
                  <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                </ActionIcon>
              </Box>
              <SimpleGrid cols={3} verticalSpacing="md" spacing="xs">
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Show Price Origin</Text>
                  <Badge variant="light" leftSection={general.showPriceOrigin ? <IconCircleCheckFilled size={16}/> : <IconCircleXFilled size={16} />} color={general.showPriceOrigin ? 'teal' : 'red'} tt='capitalize' fw='500' mb={4}>{general.showPriceOrigin ? 'Enable' : 'Disabled'}</Badge>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Show Landed Only</Text>
                  <Badge variant="light" leftSection={general.showLandedOnly ? <IconCircleCheckFilled size={16}/> : <IconCircleXFilled size={16} />} color={general.showLandedOnly ? 'teal' : 'red'} tt='capitalize' fw='500' mb={4}>{general.showLandedOnly ? 'Enable' : 'Disabled'}</Badge>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Landed Exclude VAT</Text>
                  <Badge variant="light" leftSection={general.landedExcludeVat ? <IconCircleCheckFilled size={16}/> : <IconCircleXFilled size={16} />} color={general.landedExcludeVat ? 'teal' : 'red'} tt='capitalize' fw='500' mb={4}>{general.landedExcludeVat ? 'Enable' : 'Disabled'}</Badge>
                </Box>
              </SimpleGrid>
            </Paper>
            </Grid.Col>
            <Grid.Col span={7}>
              <Paper shadow="xs" p='md' withBorder style={{ position:'relative' }}>
                <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditCurrency(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Box>
                <SimpleGrid cols={4} verticalSpacing="md" spacing="xs">
                <Box>
                  <Text fz={12} c='gray.6' mb={7}>Goods Currency</Text>
                  <Text fz={14} fw='500'>{summary.goodsCurrency}</Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={7}>Order Currency</Text>
                  <Text fz={14} fw='500'>{summary.orderCurrency}</Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={7}>Goods Currency Rate</Text>
                  <Text fz={14} fw='500'><NumberFormatter thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.goodsCurrencyRate} /></Text>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={7}>Custom Currency Rate</Text>
                  <Text fz={14} fw='500'><NumberFormatter thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.customCurrencyRate} /></Text>
                </Box>
              </SimpleGrid>
              </Paper>
            </Grid.Col>
          </Grid>
        </Box>
        <Box mb={20}>
          <Grid align='center' overflow='hidden'>
            <Grid.Col span={8}>
              <Paper shadow="xs" p={28} overflow='hidden' withBorder style={{ position:'relative' }}>
                <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditGeneralInfo(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Box>
                <SimpleGrid cols={5} verticalSpacing="md" spacing="xs">
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Type</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{summary.type}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Category</Text>
                    <Badge variant="light" color='black' tt={summary.category === 'cod' ? 'uppercase' : 'capitalize'} fw='500' mb={4}>{summary.category ? summary.category : 'No Category'}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Terms</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{general.terms ? general.terms : 'No Terms'}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Load Type</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{general.loadType ? general.loadType : 'No Load Type'}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Undername</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{general.undername ? general.undername : 'No Undername'}</Badge>
                  </Box>
                </SimpleGrid>
              </Paper>
            </Grid.Col>
            <Grid.Col span={2}>
              <Paper shadow="xs" p={20.25} overflow='hidden' withBorder style={{ position:'relative' }}>
                <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditPaymentStatus(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Box>
                <Text fz={12} c='gray.6' mb={4}>Payment Status</Text>
                  <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{summary.paymentStatus}</Badge>
                  {summary.paymentStatusDate ? <Text fz={10} c='gray.6'>{dayjs(summary.paymentStatusDate).format('DD/MMMM/YYYY')}</Text> : <Box my={14}/>}
              </Paper>
            </Grid.Col>
            <Grid.Col span={2}>
              <Paper shadow="xs" p={20.25} overflow='hidden' withBorder style={{ position:'relative' }}>
                <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditOrderStatus(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Box>
                <Text fz={12} c='gray.6' mb={4}>Order Status</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{summary.orderStatus}</Badge>
                    {summary.additionalOrderStatus ? <Text fz={10} c='gray.6'>{dayjs(summary.additionalOrderStatus.date).format('DD/MMMM/YYYY')}</Text> : <Box my={14}/>}
              </Paper>
            </Grid.Col>
          </Grid>
        </Box>
        <Box mb={20}>
          <Grid align='center' overflow='hidden'>
            <Grid.Col span={2}>
              <Paper shadow="xs" p={22} overflow='hidden' withBorder style={{ position:'relative' }}>
                <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditOrderFreight(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Box>
                <Text fz={12} c='gray.6' mb={4}>Freight</Text>
                <Text fz={14} fw='600' c='blue'><NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={general.freightValue} /></Text>
                <Text fz={12} fw='500' c='gray.6'><NumberFormatter prefix={`${summary.goodsCurrency} `} thousandSeparator="," value={general.freightOriginalValue} /></Text>
              </Paper>
            </Grid.Col>
            <Grid.Col span={2}>
              <Paper shadow="xs" p={22} overflow='hidden' withBorder style={{ position:'relative' }}>
                <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditOrderInsurence(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Box>
                <Text fz={12} c='gray.6' mb={4}>Insurence</Text>
                <Text fz={14} fw='600' c='blue'><NumberFormatter prefix={`${summary.orderCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={general.insuranceValue} /></Text>
                <Text fz={12} fw='500' c='gray.6'><NumberFormatter prefix={`${summary.goodsCurrency} `} thousandSeparator="," value={general.insurenceOriginalValue} /></Text>
              </Paper>
            </Grid.Col>
            <Grid.Col span={8}>
              <Paper shadow="xs" p={14} overflow='hidden' withBorder style={{ position:'relative' }}>
                <Box style={{ position: 'absolute', right: 1, top: 0 }}>
                  <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditPaymentMethod(true)}>
                    <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon>
                </Box>
                <Box>
                  <Text fz={12} c='gray.6' mb={4}>Payment Method</Text>
                  <OrderPaymentMethod />
                </Box>
              </Paper>
            </Grid.Col>
          </Grid>
        </Box>
        <Box mb={20}>
          <Grid style={{ gridAutoRows: '' }}>
            <Grid.Col span={4}>
              <Card shadow="sm" padding="md" radius="sm" withBorder>
                <Card.Section withBorder inheritPadding py={4} px={12}>
                  <Group justify='space-between' align='center'>
                    <Text fz={12} fw='bold'>Agent Information</Text>
                    <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => setOpenEditAgent(true)}>
                      <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                    </ActionIcon>
                  </Group>
                </Card.Section>
                <Box mt={12} mih={246}>
                  {loadingUserAgent ? loadingDataUser() : mappingUserAgent(detailUserAgent)}
                  <Text fz={14} fw='600' c='gray.6'>Commision: <NumberFormatter prefix='Rp ' thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={summary.agentCommision} /></Text>
                </Box>
              </Card>
            </Grid.Col>
            <Grid.Col span={4}>
              <Card shadow="sm" padding="md" radius="sm" withBorder>
                <Card.Section withBorder inheritPadding py={4} px={12}>
                  <Group justify='space-between' align='center'>
                    <Text fz={12} fw='bold'>Billing Information</Text>
                    <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => [setOpenEditShippingOrder(true), setTypeShipping('billing')]}>
                      <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                    </ActionIcon>
                  </Group>
                </Card.Section>
                <Box mt={12}>
                  <Box mb={14}>
                    <Text fz={12} c='gray.6' mb={1}>Full Name:</Text>
                    <Box h={25}>
                      <Text fz={12} fw='600'>{!isLoadingOrder && general.billingInformation ? general.billingInformation.first_name : '-'}</Text>
                      <Text fz={12} fw='600'>{!isLoadingOrder && general.billingInformation ? general.billingInformation.last_name : '-'}</Text>
                    </Box>
                  </Box>
                  <Box mb={14}>
                    <Text fz={12} c='gray.6' mb={1}>Address:</Text>
                    <Box h={50}>
                      <Text fz={12} fw='600' lineClamp={4}>{!isLoadingOrder && general.billingInformation ? general.billingInformation.address_1 : '-'}</Text>
                    </Box>
                  </Box>
                  <Box mb={14}>
                    <Text fz={12} c='gray.6' mb={1}>Phone:</Text>
                    <Box>
                      <Text fz={12} fw='600'>{!isLoadingOrder && general.billingInformation ? general.billingInformation.phone ? general.billingInformation.phone : '-' : ''}</Text>
                    </Box>
                  </Box>
                  <Box mb={14}>
                    <Text fz={12} c='gray.6' mb={1}>Email:</Text>
                    <Box>
                      <Text fz={12} fw='600'>{!isLoadingOrder && general.billingInformation ? general.billingInformation.email ? general.billingInformation.email : '-' : ''}</Text>
                    </Box>
                  </Box>
                </Box>
              </Card>
            </Grid.Col>
            <Grid.Col span={4}>
              <Card shadow="sm" padding="md" radius="sm" withBorder>
                <Card.Section withBorder inheritPadding py={4} px={12}>
                  <Group justify='space-between' align='center'>
                    <Text fz={12} fw='bold'>Shipping Information</Text>
                    <ActionIcon variant="transparent" size='lg' color='blue' onClick={() => [setOpenEditShippingOrder(true), setTypeShipping('shipping')]}>
                      <IconPencilMinus style={{ width: '70%', height: '70%' }} stroke={1.5} />
                    </ActionIcon>
                  </Group>
                </Card.Section>
                <Box mt={12}>
                  <Box mb={14}>
                    <Text fz={12} c='gray.6' mb={1}>Full Name:</Text>
                    <Box h={25}>
                      <Text fz={12} fw='600'>{!isLoadingOrder && general.shippingInformation ? general.shippingInformation.first_name : '-'}</Text>
                      <Text fz={12} fw='600'>{!isLoadingOrder && general.shippingInformation ? general.shippingInformation.last_name : '-'}</Text>
                    </Box>
                  </Box>
                  <Box mb={14}>
                    <Text fz={12} c='gray.6' mb={1}>Address:</Text>
                    <Box h={50}>
                      <Text fz={12} fw='600' lineClamp={4}>{!isLoadingOrder && general.shippingInformation ? general.shippingInformation.address_1 : ''}</Text>
                    </Box>
                  </Box>
                  <Box mb={14}>
                    <Text fz={12} c='gray.6' mb={1}>Phone:</Text>
                    <Box>
                      <Text fz={12} fw='600'>{!isLoadingOrder && general.shippingInformation ? general.shippingInformation.phone ? general.shippingInformation.phone : '-' : ''}</Text>
                    </Box>
                  </Box>
                  <Box mb={14}>
                    <Text fz={12} c='gray.6' mb={1}>Email:</Text>
                    <Box>
                      <Text fz={12} fw='600'>{!isLoadingOrder && general.shippingInformation ? general.shippingInformation.email ? general.shippingInformation.email : '-' : ''}</Text>
                    </Box>
                  </Box>
                </Box>
              </Card>
            </Grid.Col>
          </Grid>
        </Box>
      </Box>
      <Drawer position='right' title='Edit Custom Payment' opened={openEditCustomPayment} onClose={onCloseFormCustomPayment} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustCustomPayment onCloseForm={onCloseFormCustomPayment} />
      </Drawer>
      <Drawer position='right' title='Edit Currency' size='lg' opened={openEditCurrency} onClose={onCloseFormCurrency} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustCurrency onCloseForm={onCloseFormCurrency} />
      </Drawer>
      <Drawer position='right' title='Update general info' opened={openEditGeneralInfo} onClose={onCloseFormGeneralInfo} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustGeneralInfo onCloseForm={onCloseFormGeneralInfo} />
      </Drawer>
      <Drawer position='right' title='Update payment status' opened={openEditPaymentStatus} onClose={onCloseFormPaymentStatus} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustPaymentStatus onCloseForm={onCloseFormPaymentStatus} />
      </Drawer>
      <Drawer position='right' title='Update order status' size='xl' opened={openEditOrderStatus} onClose={onCloseFormOrderStatus} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustOrderStatus onCloseForm={onCloseFormOrderStatus} />
      </Drawer>
      <Drawer position='right' title='Update Freight Cost' opened={openEditOrderFreight} onClose={onCloseFormOrderFreight} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustOrderFreight onCloseForm={onCloseFormOrderFreight} />
      </Drawer>
      <Drawer position='right' title='Update Insurence Cost' opened={openEditOrderInsurence} onClose={onCloseFormOrderInsurence} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustOrderInsurence onCloseForm={onCloseFormOrderInsurence} />
      </Drawer>
      <Modal opened={openEditPaymentMethod} onClose={onCloseFormPaymentMethod} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Update Payment Method</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormAdjustPaymentMethod  onCloseForm={onCloseFormPaymentMethod} />
      </Modal>
      <Modal opened={openEditShippingOrder} onClose={onCloseFormShippingOrder} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>Update {typeShipping === 'billing' ? 'Billing' : 'Shipping'} Information</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormAdjustBillingAndShipping type={typeShipping}  onCloseForm={onCloseFormShippingOrder} />
      </Modal>
      <Drawer position='right' title='Edit agent' opened={openEditAgent} onClose={onCloseFormAgent} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustAgent onCloseForm={onCloseFormAgent} />
      </Drawer>
    </Box>
  )
}

export default OrderGeneralInfo